import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useConfirm } from '@/composables/useConfirm'
import { useUserStore } from '@/stores/user'
import useField from '@/composables/useField'
import { optionsGetter } from '@utils/helpers'
import { useModalOpener } from '@/composables/useModalOpener'
import { useTransactions } from '@/stores/transactions'
import {
  transactionsUpdateResource,
  transactionsToggleActivationResource,
  transactionsChangeStatusResource,
} from '@/services/transactions.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionEditModal',
  props: {
  promise: Promise,
  close: Function,
  info: Object,
},
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const attentionsStore = useTransactions()
const attentionsCounter = computed(() => attentionsStore.getAttentionsCount)
const props = __props

const formIsChanged = ref(false)
const stateFormIsChanged = ref(false)
const store = useUserStore()

const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const form = ref({
  id: '',
  orderId: '',
  client: '',
  lp: '',
  size: '',
  executedRate: '',
  dateNear: '',
  dateFar: '',
})

const stateForm = ref({
  status: '',
})

const question = $t('Сonfirm action')

const dateFormatter = (inputDate) => {
  const months = {
    JAN: '01', FEB: '02', MAR: '03', APR: '04', MAY: '05', JUN: '06',
    JUL: '07', AUG: '08', SEP: '09', OCT: '10', NOV: '11', DEC: '12'
  };
  if(inputDate) {
    const parts = inputDate.split('-')
    const numericMonth = months[parts[1]]
    const year = parts[2].length === 2 ? `20${parts[2]}` : parts[2]
    const newDate = `${year}-${numericMonth}-${parts[0]}`;
    return newDate
    
  } else {
    return inputDate
  }

}

watch(() => props.info, () => {
  Object.keys(form.value).forEach(key => {
    if(props.info[key]) form.value[key] = props.info[key]
  })
  stateForm.value.status = props.info.status
  form.value.dateNear = dateFormatter(props.info.dateNear)
  form.value.dateFar = dateFormatter(props.info.dateFar)
}, {immediate: true, deep: true})

watch(() => form.value, () => {
  formIsChanged.value = true
}, { deep: true})

watch(() => stateForm.value, () => {
  stateFormIsChanged.value = true
}, { deep: true})

const fields = ref([
  useField('client', $t('Client'), {
    component: 'd-control-multiselect',
    options: '',
    'show-labels': false,
    'track-by': 'id',
    'label-by': 'originalId',
    'allow-empty': false,
    cols: 'g-cols--12',
    isClient: true,
    class: (item: object): string => {
      if(item.createdByImport) return 'accent_unknown-lp'
    }
  }),
  useField('lp', $t('LP'), {
    component: 'd-control-multiselect',
    options: '',
    'show-labels': false,
    'track-by': 'id',
    'label-by': 'name',
    'allow-empty': false,
    cols: 'g-cols--12',
    isLp: true,
    class: (item: object): string => {
      if(item.createdByImport) return 'accent_unknown-lp'
    }
  }),
  useField('size', $t('Size'), {
    rules: 'floatNumbers|required',
    cols: 'g-cols--12',
  }),
  useField('executedRate', $t('Executed Rate'),{
    rules: 'numbers|required',
    cols: 'g-cols--12'
  }),
  useField('dateNear', $t('Value Date Near'), {
    component: 'd-control-flatpickr',
    config: {
      monthSelectorType: 'static',
      altInput: true,
      disableMobile: "true",
      altFormat: "d.m.Y",
      dateFormat: "Y-m-d",
    },
    cols: 'g-cols--6',
  }),
  useField('dateFar', $t('Value Date Far'), {
    component: 'd-control-flatpickr',
    config: {
      monthSelectorType: 'static',
      altInput: true,
      disableMobile: "true",
      altFormat: "d.m.Y",
      dateFormat: "Y-m-d",
    },
    rules: '',
    cols: 'g-cols--6',
  }),
  useField('status', $t('Status'), {
    component: 'd-control-multiselect',
    options: '',
    'show-labels': false,
    'track-by': 'key',
    'label-by': 'title',
    'allow-empty': false,
    cols: 'g-cols--12',
    custom: true,
    isState: true,
  }),
])


const toogleActivation = async (id) => {
  const title = $t('Successfully')
  const subtitle = $t('All changes are saved')
  try {
      await useConfirm(question)
      load.value = true
      await transactionsToggleActivationResource.execute({ id })
      load.value = false
      await useModalOpener({
      component: 'UiMessageModal',
      message:{
        title,
        subtitle,
        success: true,
        },
      })
      props.promise(true)
      props.close()
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const send = async (sendData: any, control: any) => {
  const preparedData = {
    ...sendData,
  }
  preparedData.client = preparedData.client.id
  preparedData.lp = preparedData.lp.id
  const title = $t('Successfully')
  const subtitle = $t('All data is saved')
  try {
      await useConfirm(question)
      load.value = true
      if(!preparedData.dateFar) delete preparedData.dateFar
      if(formIsChanged.value) await transactionsUpdateResource.execute({ id: form.value?.id }, {
        ...preparedData,
      })
      if(stateFormIsChanged.value) await transactionsChangeStatusResource.execute({}, {
        transactions: [form.value.id],
        status: stateForm.value.status.id
      })
      load.value = false
      attentionsCounter.value()
      await useModalOpener({
      component: 'UiMessageModal',
      message:{
        title,
        subtitle,
        success: true,
        },
      })
      props.promise(true)
      props.close()
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { attentionsStore, attentionsCounter, props, formIsChanged, stateFormIsChanged, store, emit, $t, load, dataIsSended, form, stateForm, question, dateFormatter, fields, toogleActivation, request, send, ref, computed, watch, get useSubmit() { return useSubmit }, get useConfirm() { return useConfirm }, get useUserStore() { return useUserStore }, get useField() { return useField }, get optionsGetter() { return optionsGetter }, get useModalOpener() { return useModalOpener }, get useTransactions() { return useTransactions }, get transactionsUpdateResource() { return transactionsUpdateResource }, get transactionsToggleActivationResource() { return transactionsToggleActivationResource }, get transactionsChangeStatusResource() { return transactionsChangeStatusResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})